<template>
  <div class="aboutnews-content">
    <!-- 新闻资讯 -->
    <div class="aboutnews-introduce">
      <div class="title animate__animated animate__fadeInDown animate__delay-1s">
        <!-- <div class="title-English"><span style="margin-right:20px">COMPANY</span><span>INFORMATION</span></div> -->
        <div>{{$t('news.newsInformation')}}</div>
      </div>
      <div class="aboutnews-box">
        <div class="aboutnews-box-item" v-for="(item,index) in newsList" :key="index" @click="goNewsContent(item.id)">
          <div v-if="(index + 2)%2 == 0" class="wow animate__animated animate__fadeInDown" data-wow-delay="0.5s" data-wow-duration="1.5s" style="width: 100%;height: 100%;overflow: hidden;border-radius: 18px;">
            <img :src="item.coverUrl" :alt="item.title">
            <div class="aboutnews-box-item-title">
              {{item.title}}
            </div>
          </div>
          <div v-if="(index + 2)%2 != 0" class="wow animate__animated animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="1.5s" style="width: 100%;height: 100%;overflow: hidden;border-radius: 18px;">
            <img :src="item.coverUrl" :alt="item.title">
            <div class="aboutnews-box-item-title">
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryNewsInfo.pageNum"
          :page-sizes="[6, 12, 24, 48]"
          :page-size="queryNewsInfo.pageSize"
          layout="pager"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/editNews'
export default {
  data () {
    return {
      // 获取新闻资讯列表的参数对象
      queryNewsInfo: {
        pageNum: 1, // 当前的页数
        pageSize: 6 // 当前显示的多少条数据
      },
      // 新闻资讯列表
      newsList: [],
      // 总条数
      total: 0
    }
  },
  mounted () {
    this.getNewsList()
  },
  created () {
    document.documentElement.scrollTop = 0
  },
  methods: {
    // 获取新闻资讯列表
    getNewsList () {
      getNewsList(this.queryNewsInfo).then(res => {
        if (res.code == 0) {
          const list = res.data.data.filter(item => {
            item.author = '智会云科技'
            return item
          })
          this.newsList = list
          this.total = res.data.total
          this.refreshWow()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    refreshWow () {
      this.$nextTick(() => {
        if (this.$wow && this.$wow.element && typeof this.$wow.sync === 'function') {
          this.$wow.sync()
        } else if (this.$wow && typeof this.$wow.init === 'function') {
          this.$wow.init()
        }
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.queryNewsInfo.pageSize = newSize
      // 重新获取数据
      this.getNewsList()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.newsList = []
      this.queryNewsInfo.pageNum = newSize
      // 重新获取数据
      this.getNewsList()
    },
    // 进入新闻资讯详细页面
    goNewsContent (id) {
      this.$router.push({ name: 'news-detail', params: { slug: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutnews-content{
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  .title{
    text-align: center;
    font-size: 24px;
    color: black;
    letter-spacing: 5px;
    line-height: 40px;
    margin-bottom: 40px;
    .title-English{
      font-family: cursive;
    }
  }
  .aboutnews-introduce{
    margin: 45px 0px 40px 0px;
  }
  .aboutnews-box{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 30px;
    .aboutnews-box-item{
      width: 100%;
      height: auto;
      aspect-ratio: 3 / 4;
      margin: 0;
      border-radius: 18px;
      position: relative;
      cursor: pointer;
      img{
        width: 100%;
        height: 100%;
        border-radius: 18px;
        object-fit: cover;
      }
      .aboutnews-box-item-title{
        width: 100%;
        height: 65px;
        line-height: 26px;
        background-color: rgba(160, 160, 160, 0.5);
        position: absolute;
        bottom: 0px;
        border-bottom-left-radius: 18px;
        border-bottom-right-radius: 18px;
        color: #fff;
        font-size: 18px;
        box-sizing: border-box;
        padding: 10px 20px;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        line-clamp:2;
        -webkit-line-clamp:2;
        word-break: break-word;
      }
    }
    img:hover{
      transform:scale(1.2);
    }
  }
  .pagination{
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 1199.98px) {
  .aboutnews-content {
    padding: 0 15px;

    .aboutnews-box {
      gap: 24px;
    }
  }
}

@media (max-width: 991.98px) {
  .aboutnews-content {
    .title {
      font-size: 22px;
      line-height: 36px;
    }

    .aboutnews-box {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 18px;

      .aboutnews-box-item {
        border-radius: 14px;

        img {
          border-radius: 14px;
        }

        .aboutnews-box-item-title {
          font-size: 16px;
          padding: 8px 14px;
          border-bottom-left-radius: 14px;
          border-bottom-right-radius: 14px;
        }
      }
    }
  }
}

@media (max-width: 767.98px) {
  .aboutnews-content {
    padding: 0 12px;

    .title {
      font-size: 18px;
      line-height: 30px;
      letter-spacing: 2px;
      margin-bottom: 24px;

      .title-English {
        font-size: 14px;
        line-height: 24px;
        word-break: break-word;
      }
    }

    .aboutnews-introduce {
      margin: 20px 0 30px;
    }

    .aboutnews-box {
      grid-template-columns: 1fr;
      gap: 14px;

      .aboutnews-box-item {
        border-radius: 12px;

        img {
          border-radius: 12px;
        }

        .aboutnews-box-item-title {
          height: auto;
          min-height: 56px;
          line-height: 24px;
          font-size: 14px;
          padding: 6px 10px;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }
    }
  }
}
</style>
